<div class="crop" (click)="cancel()">
  <div
    class="crop__panel"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <header class="crop__head">
      <h2 class="bk-heading crop__title" [id]="titleId">Crop image</h2>
      <button type="button" class="bk-icon-btn" aria-label="Close without saving" (click)="cancel()">
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </header>

    <!-- Canvas: drag, or focus it and use the keyboard, to move the image. -->
    <div class="crop__stage">
      <canvas
        #canvas
        class="crop__canvas"
        tabindex="0"
        role="application"
        aria-label="Crop area"
        [attr.aria-describedby]="hintId"
        (keydown)="onCanvasKeydown($event)"
        (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)"
        (mouseup)="onMouseUp()"
        (mouseleave)="onMouseUp()"
        (wheel)="onWheel($event)"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd()"
      ></canvas>
    </div>

    <!-- Zoom -->
    <div class="crop__zoom">
      <button type="button" class="bk-icon-btn crop__zoomBtn" aria-label="Zoom out" (click)="zoomOut()">
        <span class="bk-sym" aria-hidden="true">remove</span>
      </button>
      <span class="crop__scale" aria-live="polite">{{ zoomPercent }}%</span>
      <button type="button" class="bk-icon-btn crop__zoomBtn" aria-label="Zoom in" (click)="zoomIn()">
        <span class="bk-sym" aria-hidden="true">add</span>
      </button>
      <button type="button" class="crop__reset" (click)="resetZoom()">Reset</button>
    </div>

    <p class="crop__hint" [id]="hintId">
      Drag the image, or use the arrow keys, to move it. Use the buttons or the + and − keys to zoom.
    </p>

    <!-- Actions -->
    <footer class="crop__foot">
      <button type="button" class="bk-btn bk-btn--ghost" (click)="cancel()">Cancel</button>
      <button
        type="button"
        class="bk-btn bk-btn--primary"
        [disabled]="saving || !ready"
        [attr.aria-busy]="saving ? 'true' : null"
        (click)="cropImage()"
      >
        <span class="bk-sym" aria-hidden="true">check</span>
        {{ saving ? 'Saving…' : 'Save image' }}
      </button>
    </footer>
  </div>
</div>
